import Collection from "models/collection";
import services from "lib/HEXServices";
import userStore from "data/userStore";
import withOver, { appAlert } from "lib/withOver";
import formRegistry from "lib/hex/views/formRegistry";
import BaseServices from "lib/BaseServices";

const dateFromParts = parts =>
    new Date(parts[0], parts[1] - 1, parts[2]);

class HEXController extends Backbone.Controller {

    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
        this.onGetHarvestHistory = this.onGetHarvestHistory.bind(this);
        this.onError = this.onError.bind(this);
        this.onGetExport = this.onGetExport.bind(this);
    }

    initialize(options){
        this.model = options.model;
    }

    onGetHarvestHistory() {
        withOver("Loading Harvest History...", () =>
            services.loadHexHistory(userStore.getActiveOrgKey())
                .done(data => {
                    const results = new Collection();
                    const allowedExportTypes = new Set(userStore.getHexForms()
                        .map(f => f.key));
                    _(data).each(function (h) {
                        h.requestedAt = new Date(h.requestedAt);

                        if (h.start != null) h.start = dateFromParts(h.start);
                        if (h.end != null) h.end = dateFromParts(h.end);

                        if (h.params.start != null) {
                            h.params.start = dateFromParts(h.params.start);
                        }
                        if (h.params.end != null) {
                            h.params.end = dateFromParts(h.params.end);
                        }

                        const form = formRegistry[h.typeKey];
                        h.allowRerun = form &&
                            form.canRerun &&
                            form.canRerun(h.params) &&
                            allowedExportTypes.has(h.typeKey);

                        const m = new Backbone.Model({ id: h.id, data: h });
                        results.add(m);
                    });

                    this.model.set("results", results);
                })
                .error(this.onError),
        );
    }

    onError(jqXHR){
        if (jqXHR.status < 500) return;
        console.error(jqXHR);
        appAlert("An error has occurred.");
    }

    onGetHexDownload(id, filename){
        return services.getHexDownload(userStore.getActiveOrgKey(), id, filename);
    }

    onGetExport(impl, report, data) {
        if (BaseServices.__mocked) {
            console.log(impl.toUpperCase(), report.toUpperCase(), data);
        }
        const org = userStore.getActiveOrgKey();
        withOver(
            `Queueing ${report.substr(0, 1).toUpperCase()}${report.substr(1)}...`,
            () =>
                services.getReport(org, impl, report, data)
                    .done(() => {
                        // Reload data to cause UI refresh
                        this.onGetHarvestHistory();
                    })
                    .error(this.onError)
        );
    }

    onLoadData(impl, report, options) {
        const {
            endpoint,
            params,
            onData,
            loadingMessage = "Loading...",
        } = options;
        const org = userStore.getActiveOrgKey();
        withOver(loadingMessage, () =>
            services.loadData(org, impl, report, endpoint, params)
                .done(onData)
                .error(this.onError),
        );
    }

}

HEXController.prototype.events = {
    "get:harvest_history": "onGetHarvestHistory",
    "load:data": "onLoadData",
    "get:export": "onGetExport",
    "get:hex_file_download": "onGetHexDownload",
};

export default HEXController;



// WEBPACK FOOTER //
// ./app/controllers/HEXController.js